import { useEffect } from 'react';
// Custom hook to handle clicks outside a specified ref element
const useClickOutside = (ref, callback) => {
    useEffect(() => {
        // Function to check if click is outside the provided ref
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        // Add event listener for mousedown event
        document.addEventListener('mousedown', handleClickOutside);
        // Clean up function to remove event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]); // Dependency array ensures that effect runs only when ref or callback change
};
export default useClickOutside;
